// ─────────────────────────────────────────────────────────────────────────────
// audit.js — client for the tamper-evident audit trail.
//
// Routes audit writes through the appendAudit Cloud Function so each entry is
// sealed into the per-project hash chain and the actor identity is taken from
// the verified token (a browser can't forge who did what). If the endpoint is
// unreachable, callers fall back to a direct (append-only) write so an audit
// record is never silently lost — see writeAuditLog in App.js.
// ─────────────────────────────────────────────────────────────────────────────

import { functionsBase } from "./approvals";
import { appCheckHeader } from "./appCheck";

export async function appendAudit({ projectId, entityType, entityId, action, message, metadata }) {
  const base = functionsBase();
  if (!base) throw new Error("Audit endpoint not configured (REACT_APP_FN_BASE_URL / REACT_APP_AI_PROXY_URL).");

  let idToken = "";
  try {
    const { getAuth } = await import("firebase/auth");
    const user = getAuth().currentUser;
    if (user) idToken = await user.getIdToken();
  } catch (_) { /* fall through — server rejects without a token */ }
  if (!idToken) throw new Error("Not signed in.");

  const res = await fetch(`${base}/appendAudit`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
      ...(await appCheckHeader()),
    },
    body: JSON.stringify({ projectId, entityType, entityId, action, message, metadata }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.error || `Audit append failed (HTTP ${res.status}).`);
  return data; // { success, id }
}
